import React from "react";
import Hero from "@/components/organisms/Hero";
import Image from "next/image";
import Title from "../atoms/Title";

const WelcomeRooms = ({ t }) => {

const imageTop = t("rooms:welcome.imageTop", { returnObjects: true } )
const imageBottom = t("rooms:welcome.imageBottom", { returnObjects: true })

  return (
    <>
      <div className="base-container my-14 ">
        <div className="base-grid ">
          <Hero
            title={{
              text: t("rooms:welcome.title"),
              className: "hero-title text-center lg:text-left",
              tag:"h1"
            }}
            text={{
              text: t("rooms:welcome.subtitle") || "",
              className: "section-subtitle text-center lg:text-left uppercase",
            }}
            paragraphs={{
              list: t("rooms:welcome.text", { returnObjects: true }),
              className: "hero-text mb-4 text-center lg:text-left leading-[28px] lg:leading-[32px]",
            }}
            styles={{
              heroContainer: "col-span-12 sm:col-span-12 md:col-span-12 lg:col-start-1 lg:col-span-6 xl:col-start-2 xl:col-span-5 mb-6",
              textContainer: "col-span-full order-1",
              titleContainer: "col-span-full order-2",
              paragraphsContainer: "col-span-full order-3",
            }}
          />

          <div className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-5 flex justify-center lg:justify-evenly gap-5">
            <div className="flex items-end h-96 lg:h-auto">
              <Image
                src={imageBottom?.src}
                width={imageBottom?.width}
                height={imageBottom?.height}
                alt={imageBottom?.alt}
                className="h-5/6 w-auto"
                
              />
            </div>
            <div className="flex items-start ">
              <Image
                src={imageTop?.src}
                width={imageTop?.width}
                height={imageTop?.height}
                alt={imageTop?.alt}
                className="h-5/6 w-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WelcomeRooms;
